import React from "react";
import DefaultLayout from "../../layouts/DefaultLayout";
import Imagecarousel from "../../components/Imagecarousel/Imagecarousel";
import TextImageSection from "../../components/Textimagesection/Textimagesection";
import FacilitiesSection from "../../components/Facilitiessection/Facilitiessection";
import { useTranslation } from 'react-i18next';
import "./Home.css";

const Home = () => {
  const { t } = useTranslation();
  const images = [
    { src: "assets/Images/Nieuwpoort-57.jpg", alt: "Living room 2" },
    { src: "assets/Images/Nieuwpoort-43.jpg", alt: "Full appartement picture to inside" },
    { src: "assets/Images/Nieuwpoort-38.jpg", alt: "Kitchen + table" },
    { src: "assets/Images/Nieuwpoort-39.jpg", alt: "Table" },
    { src: "assets/Images/Nieuwpoort-36.jpg", alt: "Google nest" },
    { src: "assets/Images/Nieuwpoort-28.jpg", alt: "Bathroom" },
    { src: "assets/Images/Nieuwpoort-35.jpg", alt: "Bedroom" },
    { src: "assets/Images/Nieuwpoort-33.jpg", alt: "Bedroom inside view" },
    { src: "assets/Images/Nieuwpoort-16.jpg", alt: "Balcony right" },
    { src: "assets/Images/Nieuwpoort-19.jpg", alt: "Balcony left" },
    { src: "assets/Images/Nieuwpoort-13.jpg", alt: "Balcony left panoramic" },
    { src: "assets/Images/Nieuwpoort-02.jpg", alt: "Beach high perspective" },
    { src: "assets/Images/Nieuwpoort-08.jpg", alt: "Statue" },
    { src: "assets/Images/Nieuwpoort-70.jpg", alt: "Living room" },
    { src: "assets/Images/Nieuwpoort-46.jpg", alt: "TV" },
    { src: "assets/Images/Nieuwpoort-45.jpg", alt: "Chair" },
    { src: "assets/Images/Nieuwpoort-07.jpg", alt: "Beach" },
    { src: "assets/Images/Nieuwpoort-51.jpg", alt: "TV+Chair" },
  ];
  const facilities = {
    facilitiesGeneral: [
      t("Gratis Wi-Fi"),
      t("Geen huisdieren toegelaten"),
      t("Elektrische verwarming"),
      t("8e verdiep"),
      t("Zongericht terras bij de slaapkamer"),
      t("Afzonderlijk toilet"),
      t("Praktische berging"),
    ],
    facilitiesLivingroom: [
      t("Flatscreen Smart-TV"),
      t("Radio"),
      t("Zetelbed voor 2 personen 1m60 (1x donsdeken 2 p.)"),
      t("Digitale televisieaansluiting"),
    ],
    facilitiesKitchen: [
      t("Tradiotionele oven"),
      t("Keramische kookplaat"),
      t("Vaatwasser"),
      t("Combi oven"),
      t("Koffiezetapparaat"),
      t("Frigo met diepvriesvak"),
    ],
    facilitiesSleepRoom: [t("Dubbel bed 1m60"), t("1x donsdeken")],
    facilitiesBathRoom: [t("Ligbad met douchescherm")],
  };

  return (
    <div>
      <DefaultLayout className="body">
        <div id="home-container">
          {/*Text and Image Section */}
          <section id="text-image-section">
            <TextImageSection
              text={t('welcome')}
              imagesrc="assets/Images/Nieuwpoort-57.jpg"
              alttext="Living Room"
            />
            <TextImageSection
              text={t('description')}
              imagesrc="assets/Images/Nieuwpoort-35.jpg"
              alttext="foto 11"
              left={false}
            />
          </section>

          {/* Booking Section */}
          <section id="booking-section">
            <div className="booking-content">
              <img
                src="assets/Images/ERALogo.png"
                alt="ERA Logo"
                className="era-logo"
              />
              <div className="booking-text">
                <h2 className="sectiontitle">{t('bookApartment')}</h2>
                <p>
                  {t('bookingText')}
                </p>
                <a
                  href="https://www.servimoholidays.be/nl/accommodatie/711/Tijl-0801"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="booking-button"
                >
                  {t('bookNow')}
                </a>
              </div>
            </div>
          </section>

          {/* Facilities Section */}
          <section id="Facilities-section">
            <h2 className="sectiontitle">{t('facilities')}</h2>
            <FacilitiesSection
              title={t('general')}
              elements={facilities.facilitiesGeneral}
            />
            <FacilitiesSection
              title={t('livingRoom')}
              elements={facilities.facilitiesLivingroom}
            />
            <FacilitiesSection
              title={t('kitchen')}
              elements={facilities.facilitiesKitchen}
            />
            <FacilitiesSection
              title={t('bedroom')}
              elements={facilities.facilitiesSleepRoom}
            />
            <FacilitiesSection
              title={t('bathroom')}
              elements={facilities.facilitiesBathRoom}
            />
          </section>

          {/* Photo Carousel Section */}
          <section id="carouselsection">
            <Imagecarousel images={images} />
          </section>
        </div>
      </DefaultLayout>
    </div>
  );
};

export default Home;
